import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { ScreenSize } from '../../../shared/shared.reducer';
import { DetectPlatformService } from '../../../services/detectPlatform.service';
import { AppConfigService } from 'app/services/app-config.service';

@Component({
  selector: 'album-prices',
  templateUrl: './album-prices.component.html',
  styleUrls: ['./album-prices.component.scss'],
})
export class AlbumPricesComponent implements OnInit {
  @ViewChild('picPopup', { static: false }) picPopup;

  screenSize: ScreenSize;

  constructor(
    private store: Store<AppState>,
    public detectPlatformService: DetectPlatformService,
    public appConfigService: AppConfigService
  ) {}

  mouseover = false;
  activePicIndex = null;
  popupCoordinates = { 'left.px': '0', 'top.px': '0' };

  // todo use Api data instead hardcoded by creating new service for landing page, check issue #106
  pricesData;
  currency;

  ngOnInit() {
    this.getCountryPriceData();
    this.store.select('shared').subscribe(store => {
      this.screenSize = store.screenSize;
    });
  }

  getCountryPriceData() {
    this.appConfigService.configSubject.subscribe(config => {
      if (config.geo_info) {
        if (config.geo_info.country_code === 'CH') {
          this.currency = 'CHF ';
          this.pricesData = {
              sizes: [
                {
                  title: '10x10',
                  unit: 'cm',
                  image: '/assets/img/product/5x5.jpg',
                },
                {
                  title: '13x13',
                  unit: 'cm',
                  image: '/assets/img/product/8x8.jpg',
                },
                {
                  title: '20x20',
                  unit: 'cm',
                  image: '/assets/img/product/10x10.jpg',
                },
                {
                  title: '30x30',
                  unit: 'cm',
                  image: '/assets/img/product/12x12.jpg',
                },
              ],
              types: [
                {
                  name: 'Layflat',
                  pages: '26',
                  prices: [
                    {
                      size: '10x10',
                      basePrice: '9.95',
                      pagePrice: '0.50',
                    },
                    {
                      size: '13x13',
                      basePrice: '14.95',
                      pagePrice: '0.70',
                    },
                    {
                      size: '20x20',
                      basePrice: '29.95',
                      pagePrice: '0.95',
                    },
                    {
                      size: '30x30',
                      basePrice: '49.95',
                      pagePrice: '1.45',
                    },
                  ],
                },
              ],
            };
        } else {
          this.currency = '$';
          this.pricesData = {
            sizes: [
              {
                title: '5x5',
                unit: 'inches',
                image: '/assets/img/product/5x5.jpg',
              },
              {
                title: '8x8',
                unit: 'inches',
                image: '/assets/img/product/8x8.jpg',
              },
              {
                title: '10x10',
                unit: 'inches',
                image: '/assets/img/product/10x10.jpg',
              },
              {
                title: '12x12',
                unit: 'inches',
                image: '/assets/img/product/12x12.jpg',
              },
            ],
            types: [
              {
                name: 'Layflat',
                pages: 16,
                prices: [
                  {
                    size: '5x5',
                    basePrice: 9.95,
                    pagePrice: 0.39,
                  },
                  {
                    size: '8x8',
                    basePrice: 19.95,
                    pagePrice: 0.59,
                  },
                  {
                    size: '10x10',
                    basePrice: 29.95,
                    pagePrice: 0.89,
                  },
                  {
                    size: '12x12',
                    basePrice: 39.95,
                    pagePrice: 1.19,
                  },
                ],
              },
            ],
          };
        }
      }
    });
  }

  mouseenter(ev, i) {
    ev.preventDefault();
    if (!this.isPopupEnabled) {
      return;
    }
    this.mouseover = true;
    this.activePicIndex = i;
  }
  mouseleave() {
    if (!this.isPopupEnabled) {
      return;
    }
    this.mouseover = false;
  }
  mousemove(ev) {
    ev.preventDefault();
    if (!this.picPopup || !this.isPopupEnabled) {
      return;
    }

    const { x, y } = ev;
    const { innerWidth, innerHeight } = window;
    const {
      width,
      height,
    } = this.picPopup.nativeElement.getBoundingClientRect();

    this.setPopupCoordinates('left', x, innerWidth - x < width && width);
    this.setPopupCoordinates('top', y, innerHeight - y < height && height);
  }

  setPopupCoordinates(property, mouseAxis, length = 0) {
    const delta = length ? -10 : 10;
    this.popupCoordinates[`${property}.px`] = `${mouseAxis + delta - length}`;
  }

  get isPopupEnabled() {
    return (
      this.screenSize.exactOrBiggerThan.md &&
      !this.detectPlatformService.isMobilePlatform
    );
  }

  get isCarouselEnabled() {
    return this.detectPlatformService.isMobilePlatform;
  }

  get showPicPopup() {
    return this.mouseover && this.isPopupEnabled;
  }
}
